import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { Address, zeroAddress } from 'viem';

import { teamBoostHistoryQuery } from './teamBoostHistoryQuery';

export const useTeamBoostHistoryQuery = (
  userAddress?: Address,
  size?: number,
) => {
  const [page, setPage] = useState(1);
  const reactQueryOptions = useMemo(() => {
    const param = {
      userAddress: userAddress?.toLowerCase() ?? zeroAddress,
      page: page - 1,
      size: size ?? 10,
    };
    
return queryOptions({
      queryKey: teamBoostHistoryQuery.getKey(param),
      queryFn: teamBoostHistoryQuery.getFn(param),
      enabled: !!userAddress,
    });
  }, [userAddress, page]);

  const query = useQuery(reactQueryOptions);

  return {
    query,
    setPage,
  };
};
